import { PimEyes, BingSearch, TinEyeSearch } from "./ProviderGallery";
import { VisualSearchProviders } from "src/share/types/visualSearch";

const visualSearchFactoryOptions = (images, removeInvalidImage, isFetchingData) =>  ({
  [VisualSearchProviders.PIMEYES]: PimEyes(images, removeInvalidImage),
  [VisualSearchProviders.TINEYE]:TinEyeSearch(images, removeInvalidImage, isFetchingData),
  [VisualSearchProviders.BING]: BingSearch(images)
});

const visualSearchFactory = (type: VisualSearchProviders, images, removeInvalidImage, isFetchingData) => {
  return visualSearchFactoryOptions(images, removeInvalidImage, isFetchingData)[type];
};

export default visualSearchFactory;




// WEBPACK FOOTER //
// ./src/modules/AdHocTools/VisualSearch/components/visualSearch.factory.tsx